import React, { useRef, useState, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/scrollbar/scrollbar.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/swiper.styles";
import ReactCursorPosition from "react-cursor-position";
import SwiperCursor from "../../SwiperCursor";

SwiperCore.use([Autoplay]);

const useStyles = makeStyles(styles);

function SwiperComponent({ slides, setSlider }) {
  // state
  const [index, setIndex] = useState(0);

  function handleIndexChanged(i) {
    if (i === index) return; // dont update
    setIndex(i);
  }
  const swiperRef = useRef(null);
  const scrollBarRef = useRef(null);
  function moveSwiper(action) {
    stopAutoplay();
    if (swiperRef.current) swiperRef.current.swiper[action](1200, false);
  }
  function stopAutoplay() {
    if (swiperRef.current) swiperRef.current.swiper.autoplay.stop();
  }
  function getScrollBarWidth() {
    if (scrollBarRef.current) return scrollBarRef.current.offsetWidth;
  }
  const goBack = () => moveSwiper("slidePrev");
  const goForwards = () => moveSwiper("slideNext");
  // styles
  const props = { numberOfItems: slides.length };
  const classes = useStyles(props);
  // slide components
  const photos = slides.map((e, i) => {
    return (
      <SwiperSlide key={i} className={classes.span}>
        <img alt="slides" className={classes.slideImg} src={e.src} />
        <p className={classes.slideText}>{e.text}</p>
      </SwiperSlide>
    );
  });

  return (
    <div
      style={{ position: "relative", cursor: "none" }}
      onMouseEnter={() => setSlider(true)}
      onMouseLeave={() => setSlider(false)}
    >
      <ReactCursorPosition className="fullParent">
        <SwiperCursor goForwards={goForwards} goBack={goBack} />
      </ReactCursorPosition>
      <Swiper
        slidesPerView="auto"
        spaceBetween={0}
        centeredSlides
        speed={4000}
        observeParents
        observer
        autoplay={{
          delay: 1,
          disableOnInteraction: true,
        }}
        loop
        onSlideChange={(i) => handleIndexChanged(i.realIndex)} // save index in state
        ref={swiperRef}
        className={classes.swiper}
      >
        <div className={classes.leftDiv}></div>
        {photos}
        <div className={classes.rightDiv}></div>
      </Swiper>
      <div ref={scrollBarRef} className={classes.scrollBarWrap}>
        <span
          className={classes.scrollDrag}
          style={{
            transform: `translateX(${index * (getScrollBarWidth() / 6)}px)`,
            width: `${getScrollBarWidth() / 6}px`,
          }}
        ></span>
      </div>
    </div>
  );
}

export default memo(SwiperComponent);